/** Registers the TileMap parser and property formatter. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTileMap } from './parser';
import { formatTileMapProperties } from './propertyFormatter';
const tileMapRegistration = {
    typeName: 'TileMap',
    parser: parseTileMap,
    propertyFormatter: formatTileMapProperties,
};
nodeRegistry.register(tileMapRegistration);
//# sourceMappingURL=index.js.map